import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
import { relationshipsOrganizationTypeSchema, relationshipsOrganizationStatusSchema } from '../contracts/relationships-organization.contract.js';
const label = z.string().trim().min(1).max(300);
export const relationshipsOrganizationEditCopySchema = z.strictObject({
    edit: label, name: label, type: label, status: label, addressLine1: label, addressLine2: label,
    city: label, region: label, postalCode: label, countryCode: label, website: label, notes: label,
    phone: label, email: label, privateHidden: label, save: label, saving: label, cancel: label,
    invalid: label, unchanged: label, uncertain: label, verify: label, saved: label,
    typeLabels: z.record(relationshipsOrganizationTypeSchema, label),
    statusLabels: z.record(relationshipsOrganizationStatusSchema, label),
});
export const relationshipsOrganizationEditCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.organization-edit', moduleId: 'relationships', title: 'Organization editing copy',
        helpText: 'Labels for authorized organization profile edits and save verification.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            edit: 'Edit organization', name: 'Name', type: 'Type', status: 'Status',
            addressLine1: 'Street address', addressLine2: 'Unit or suite', city: 'City', region: 'State or region',
            postalCode: 'ZIP or postal code', countryCode: 'Country code', website: 'Website', notes: 'Profile notes',
            phone: 'Phone', email: 'Email', privateHidden: 'Private phone and email fields are hidden and will be left unchanged.',
            save: 'Save organization', saving: 'Saving and checking…', cancel: 'Cancel',
            invalid: 'Check the organization fields before saving.', unchanged: 'No changes to save.',
            uncertain: 'The save could not be confirmed. Your draft is retained. Check saved values before another save.',
            verify: 'Check saved values', saved: 'Organization saved and checked.',
            typeLabels: { customer: 'Customer', insurance: 'Insurance', vendor: 'Vendor', adjuster: 'Adjuster',
                property_manager: 'Property manager', other: 'Other' },
            statusLabels: { active: 'Active', difficult: 'Difficult', preferred: 'Preferred', inactive: 'Inactive' },
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsOrganizationEditCopySchema,
});
//# sourceMappingURL=relationships-organization-edit-copy.js.map